import {
  API_REQUEST,
} from '../middlewares/authMiddleware.js';

import { replace } from 'react-router-redux';

export const LOGIN_REQUEST = Symbol('LOGIN_REQUEST');
export const LOGIN_SUCCESS = Symbol('LOGIN_SUCCESS');
export const LOGIN_FAILED = Symbol('LOGIN_FAILED');
export const LOGOUT = Symbol('LOGOUT');

export function logout() {
  return dispatch => {
    dispatch({
      type: LOGOUT,
    });

    dispatch(replace('/'));
  };
}

export function login(account, password) {
  return {
    [API_REQUEST]: {
      types: [
        LOGIN_SUCCESS,
        LOGIN_FAILED,
        LOGIN_REQUEST,
      ],
      method: 'POST',
      entrypoint: '/auth/login',
      json: true,
      body: {
        account,
        password,
      },
    },
  };
}



// WEBPACK FOOTER //
// ./actions/Auth.js